import { useState } from 'react';
import { useDispatch } from 'react-redux';
import classNames from 'classnames';
import dayjs from 'dayjs';

import Button from 'atoms/button';
import Icon from 'atoms/icon';
import useWindowDimensions from 'hooks/useWindowDimensions';
import AvailabilityRange from 'organisms/DrawerContent/Availability/Components/DayAvailability/AvailabilityRange';
import {
  addPlaceholder,
  editPlaceholder,
  removeRange,
} from 'store/reducers/singleUnavailability';
import { generateKey, getTimeFromDate } from 'util';

export default function UnavailabilityRangeList({ dayData, date }) {
  const dispatch = useDispatch();
  const { width } = useWindowDimensions();
  // This is responsible for the animation upon deletion
  const [itemsToAnimate, setItemsToAnimate] = useState([]);
  const isMobile = width < 460;

  const addPlaceholderRange = () => {
    dispatch(addPlaceholder({ date }));
  };

  const onRemoveRange = ({ uuid, isPlaceholder }) => {
    setItemsToAnimate([...itemsToAnimate, uuid]);
    setTimeout(() => {
      dispatch(
        removeRange({
          uuid,
          isPlaceholder,
        })
      );
      const remainingItems = itemsToAnimate.filter((el) => el !== uuid);
      setItemsToAnimate(remainingItems);
    }, 400);
  };

  return (
    <div
      className={classNames(
        'flex-column availability-day align-start border-light-purple mb-12 p-24 radius-24'
      )}
    >
      <h4 className="mb-10">{dayjs(new Date(date)).utc().format('ddd DD')}</h4>
      <div className="flex-column w-100">
        {dayData.map((range, i) => (
          <div
            key={generateKey()}
            className={classNames(
              'flex-row w-100',
              i < dayData.length - 1 && 'mb-15',
              itemsToAnimate.includes(range.uuid) &&
                dayData.length > 1 &&
                'deleted-animation deleted-animation-origin-single'
            )}
          >
            <AvailabilityRange
              day={dayjs(new Date(date)).format('dddd')}
              range={{
                ...range,
                start: getTimeFromDate(range.start),
                end: getTimeFromDate(range.end),
              }}
              editSlot={editPlaceholder}
            />
            <div className="action-buttons flex-row">
              <Icon
                name="bin"
                className="ml-10"
                onClick={() => {
                  onRemoveRange({
                    uuid: range.uuid,
                    isPlaceholder: range.isPlaceholder,
                  });
                }}
              />
              <div
                className="flex-row"
                style={{
                  visibility: i === dayData.length - 1 ? 'visible' : 'hidden',
                }}
              >
                <Icon
                  name="close"
                  className="plus-icon ml-10"
                  style={{
                    fill: '#63637B',
                    width: 14,
                    height: 14,
                  }}
                  onClick={addPlaceholderRange}
                />
              </div>
            </div>
          </div>
        ))}
        {isMobile ||
          (dayData.length === 0 && (
            <Button
              size="small"
              text="Add unavailable time"
              variant="reverse"
              className="w-fit mt-10"
              onClick={addPlaceholderRange}
            />
          ))}
      </div>
    </div>
  );
}
